import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './orders.module.scss';
import { getObjectValue } from '../../utility/utills';

const RenderScreens = ({
  data,
  // isHeight,
  isContinuousScroll,
  onClickMenu,
  menu
}) => {
  const handleError = (e) => {
    e.target.style.visibility = 'hidden';
    e.target.style.maxHeight = '65%';
    e.target.className = 'row col-12';
  };
  const handleClick = (e) => {
    const headers = [...document.querySelectorAll('[data-header]')];
    const sections = [...document.querySelectorAll('[data-section]')];
    const nonContinousScroll = document.getElementById('nonContinousScroll');
    const section = sections.find((d) => d.id === e.target.id);
    if (section && isContinuousScroll) {
      section.scrollIntoView();
    }
    if (!isContinuousScroll) {
      nonContinousScroll.scrollTo(0, 0);
      window.sessionStorage.setItem('screenId', e.target.id);
      onClickMenu(e.target.id);
    }
    headers.forEach((header) => {
      const Header = header;
      if (header.id === e.target.id) {
        Header.classList = `w-100 col-12 col-lg-12 h-100 row align-items-center justify-content-center px-0 ${styles.selectedMenu} od-container-card-border border-color-primary`;
      } else {
        Header.classList = 'w-100 col-12 col-lg-12 h-100 row align-items-center justify-content-center px-0 opacity-50 od-text-secondary text-secondary';
      }
    });
  };

  useEffect(() => {
    const screenId = window.sessionStorage.getItem('screenId');
    if (screenId && !isContinuousScroll) {
      onClickMenu(screenId);
    } else if (!isContinuousScroll) {
      window.sessionStorage.setItem('screenId', menu[0].id);
      onClickMenu(menu[0].id);
    }
  }, []);

  return (
    <div
      data-header={data.id}
      onClick={(e) => handleClick(e)}
      id={data.id}
      className={cn('row col-12 px-0 align-items-center h-100 justify-content-center')}
      role="presentation"
      // style={{ height: isHeight ? '125px' : '200px' }}
    >
      {data.imageUrl ? (
        <img className="img-fluid img-responsive w-100 d-block mx-auto p-0" src={data.imageUrl} alt={data.name} id={data.id} style={{ objectFit: 'contain', height: '60%' }} onError={handleError} />
      ) : (
        <div className="col-12 w-100 text-center w-100 p-0" style={{ maxHeight: '60%' }}>No Image Found</div>
      )}
      <div className={cn('col-12 d-flex align-items-center justify-content-center text-center text-primary od-text-primary d-block h-40', data.name.length > 30 && 'text-truncate', data.name.length > 12 ? 'fs-12 px-1' : 'fs-18')} style={!data.suppressNameInTileView ? { visibility: 'visible' } : { visibility: 'hidden' }} id={data.id}>{data.name}</div>
    </div>
  );
};

const KioskScrollMenu = (props) => {
  const menu = props.menusList?.length > 0 && props.menusList[0]?.screens;

  useEffect(() => {
    const screenId = window.sessionStorage.getItem('screenId');
    const head = [...document.querySelectorAll('[data-header]')];
    if (!screenId) {
      window.sessionStorage.setItem('screenId', getObjectValue(() => menu[0].id, 0));
    }
    if (head) {
      head.forEach((header) => {
        const Header = header;
        if (Number(header.id) === Number(screenId || getObjectValue(() => menu[0].id, 0))) {
          Header.classList = `w-100 col-12 col-lg-12 row align-items-center h-100 justify-content-center px-0 ${styles.selectedMenu} od-container-card-border border-color-primary`;
          header.scrollIntoView();
        }
      });
    }
  }, []);

  return (
        <div className={cn('col-12 d-flex p-0 align-items-center overflowX h-100', menu && menu.length <= 3 && 'justify-content-center')}>
          {menu?.map((item) => (
            <div key={item.id} className="row col-3 h-90 justify-content-center mx-1 p-0">
              <RenderScreens
                data={item}
                menu={menu}
                isHeight={props.isHeight}
                isContinuousScroll={props.isContinuousScroll}
                onClickMenu={props.onClickMenu}
              />
            </div>
          ))}
        </div>
  );
};

export default KioskScrollMenu;
